/**
 * Restore password form module
 *
 * @module views/sessions/restoration-input
 */
define('views/auth/restoration-input',['require','jquery','mediator','helpers/application','views/base/form','text!templates/auth/restoration-input.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        mediator = require('mediator'),
        applicationHelper = require('helpers/application'),
        FormView = require('views/base/form'),
        template = require('text!templates/auth/restoration-input.ejs');

    var RestoreInputView = FormView.extend({
        template: template,
        className: 'restoration-form modal-backdrop dark in',
        region: 'session',
        customValidation: true,

        events: {
            'click [data-action=back]': 'back',
        },

        back: function(event){
            event.preventDefault();
            applicationHelper.redirectTo('auth#login', {}, { forceStartup: true });
        },

        save: function() {
            var _this = this;
            var model = this.model;

            model.save()
                .done(function(response) {
                    console.log('done', arguments);
                    applicationHelper.redirectTo('auth#restorationConfirm', response);
                })
                .fail(function() {
                    console.log('fail', arguments);
                    _this.errorMessages = ['Такой номер телефона в системе не зарегистрирован.'];
                    _this.render();
                });
        },

        render: function() {
            FormView.prototype.render.apply(this, arguments);
            $('html').addClass('modal-visible');
        },

        dispose: function() {
            if (this.disposed) { return; }

            $('html').removeClass('modal-visible');

            FormView.prototype.dispose.apply(this, arguments);
        }
    });

    return RestoreInputView;
});

